/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  PostApiV1Coupon202,
  PostApiV1Coupon400,
  PostApiV1Coupon401,
  PostApiV1Coupon409,
  PostApiV1Coupon500,
  PostApiV1CouponMutationRequest,
  PostApiV1CouponMutationResponse,
} from "../../types/couponRegistroController/PostApiV1Coupon.ts";
import { couponViewModelSchema } from "../couponViewModelSchema.ts";
import { createCouponRequestViewModelSchema } from "../createCouponRequestViewModelSchema.ts";

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const postApiV1Coupon202Schema = z.lazy(
  () => couponViewModelSchema,
) as unknown as ToZod<PostApiV1Coupon202>;

/**
 * @description (Bad Request) Requisição em formato incorreto ou com dados faltantes.
 */
export const postApiV1Coupon400Schema =
  z.any() as unknown as ToZod<PostApiV1Coupon400>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const postApiV1Coupon401Schema =
  z.any() as unknown as ToZod<PostApiV1Coupon401>;

/**
 * @description (Conflict) Há um conflito com os dados existentes.
 */
export const postApiV1Coupon409Schema =
  z.any() as unknown as ToZod<PostApiV1Coupon409>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const postApiV1Coupon500Schema =
  z.any() as unknown as ToZod<PostApiV1Coupon500>;

export const postApiV1CouponMutationRequestSchema = z.lazy(
  () => createCouponRequestViewModelSchema,
) as unknown as ToZod<PostApiV1CouponMutationRequest>;

export const postApiV1CouponMutationResponseSchema = z.lazy(
  () => postApiV1Coupon202Schema,
) as unknown as ToZod<PostApiV1CouponMutationResponse>;
